import { DocumentInputType } from '~/common/model'

function isValidMSISDN(value: string) {
  return new RegExp('^[6|7][0-9]{8}$').test(value.toUpperCase())
}

function isValidCLI(value: string) {
  return new RegExp('^9|^8[0-9]{8}$').test(value.toUpperCase())
}

export const isValidNIF = (value: string) => {
  const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i
  if (!value.match(nifRexp)) {
    return false
  }
  const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE'
  const letter = dniLetters.charAt(parseInt(value, 10) % 23)
  return letter === value.charAt(8)
}

const isValidNIE = (NIE: string) => {
  const nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i
  if (!NIE.match(nieRexp)) {
    return false
  }
  let niePrefix = NIE.charAt(0)
  switch (niePrefix) {
    case 'X':
      niePrefix = '0'
      break
    case 'Y':
      niePrefix = '1'
      break
    case 'Z':
      niePrefix = '2'
      break
    default:
      return false
  }
  return isValidNIF(niePrefix + NIE.substr(1))
}

const isValidCIF = (cif: string) => {
  if (!cif || cif.length !== 9) {
    return false
  }
  const letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']
  const digits = cif.substr(1, cif.length - 2)
  const letter = cif.substr(0, 1)
  const control = cif.substr(cif.length - 1)
  let sum = 0
  let i
  let digit

  if (!letter.match(/[A-Z]/)) {
    return false
  }

  for (i = 0; i < digits.length; i += 1) {
    digit = parseInt(digits[i], 10)

    if (Number.isNaN(digit)) {
      return false
    }
    if (i % 2 === 0) {
      digit *= 2
      if (digit > 9) {
        digit = (parseInt((digit / 10).toString(), 10) + digit) % 10
      }
      sum += digit
    } else {
      sum += digit
    }
  }
  sum %= 10
  if (sum !== 0) {
    digit = 10 - sum
  } else {
    digit = sum
  }
  if (letter.match(/[ABEH]/)) {
    return String(digit) === control
  }
  if (letter.match(/[NPQRSW]/)) {
    return letters[digit] === control
  }

  return String(digit) === control || letters[digit] === control
}

const isValidPassport = (value: string) => {
  const regex = /^(?!^0+$)[A-Z0-9]{5,}$/g
  return regex.test(value)
}

export function getDocumentType(value: string) {
  // Pad nif with zeros
  if (isValidNIF(value.padStart(9, '0'))) return DocumentInputType.NIF
  if (isValidNIE(value)) return DocumentInputType.NIE
  if (isValidCIF(value)) return DocumentInputType.CIF
  if (isValidMSISDN(value)) return DocumentInputType.MSISDN
  if (isValidCLI(value)) return DocumentInputType.CLI
  if (isValidPassport(value)) return DocumentInputType.PASSPORT

  return ''
}
